const defaultState = {
  loaded: false,
  lastFetch: undefined,
  items: {}
}

const annualPassTypes = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_SEASON_PASS_TYPES': {
      let items

      action.payload.forEach(annualPassType => {
        const id = annualPassType['elektra_reduction_id']
        items = {
          ...items,
          [id]: {
            id,
            ...annualPassType
          }
        }
      })

      return {
        ...state,
        loaded: true,
        lastFetch: new Date().getTime(),
        items
      }
    }
    case 'SET_SEASON_PASS_TYPE_DETAILS': {
      const {
        annualPassType: { type_id, ...item }
      } = action.payload

      const id = item.elektra_reduction_id

      return {
        ...state,
        items: {
          ...state.items,
          [id]: {
            ...state.items[id],
            id,
            ...item
          }
        }
      }
    }
    case 'CREATE_SEASON_PASS_TYPE': {
      const item = action.payload
      const nextId = Object.keys(state.items).length + 1

      return {
        ...state,
        items: {
          ...state.items,
          [nextId]: {
            ...item,
            id: nextId
          }
        }
      }
    }
    default: {
      return state
    }
  }
}

export default annualPassTypes
